export class LaundryBaseMovement
{
    id?: number;
    userId?: number;
    username?: string;
    inputDate: Date;
    operationDate: Date;
    direction: string;
    shelfBoxId: number;
    device: string;
    status: string;

    constructor()
    {
        this.id = 0;
        this.userId = 0;
        this.inputDate = new Date();
        this.operationDate = new Date();
        this.direction = '';
        // this.shelfBoxId = 0;
        this.device = '';
        this.status = '';
    }
}


// WEBPACK FOOTER //
// ./src/app/+core/common/model/laundry-base-movement.model.ts